import React, { ReactNode, useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import Voting from "./VotingDesktop";
import Following from "./Following";
import { makeStyles } from "@material-ui/core/styles";
import { Statement } from "../../firebase/statements";
import {
  AGREE,
  DISAGREE,
  VoteType,
  getStatementVote,
} from "../../firebase/voting";
import { useAuth } from "../../firebase/AuthProvider";
import { colors } from "../../theme";
import StatementLink from "../shared/StatementLink";

interface Props {
  statement: Statement;
  titleIsLink: boolean;
  backgroundImageUrl: string;
  statementNavigation: ReactNode;
}

const useStyles = makeStyles((theme) => ({
  headerBackground: {
    height: "490px",
    width: "100%",
    zIndex: 1,
    borderRadius: "10px",
    position: "relative"
  },
  header: {
    height: "490px",
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    position: "relative",
    top: "-490px",
    marginBottom: "-490px",
    zIndex: 2,
    borderRadius: "10px",
  },
  statementContainer: {
    position: "relative",
    top: "-490px",
    marginBottom: "-490px",
    zIndex: 3,
  },
  statementNav:  {
    backgroundImage:
      "linear-gradient(to bottom, " +
      colors.STATEMENT_NAV_BG +
      ", rgba(35, 31, 32, 0) 99%)",
    position: "relative",
    zIndex: 4,
    height: "50px",
  },
  statementTitleContainer: {
    textAlign: "center",
    height: "170px",
    paddingTop: "50px",
  },
  statementTitle: {
    color: colors.STATEMENT_TITLE,
    fontFamily: "Poppins",
    fontSize: "36px",
    fontWeight: 900,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.21",
    letterSpacing: "-0.13px",
    textShadow: "1px 1px #000"
  },
  statementLink: {
    color: colors.STATEMENT_TITLE,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
  votingContainer: {
    textAlign: "center",
    paddingTop: "30px",
  },
  followContainer: {
    textAlign: "right",
  },
  container: {
    width: "100%",
    position: "absolute",
    bottom: "20px"
  },
  textContainer:  {
    width: "100%",
    position: "absolute",
  },
  followButton: {
    position: "absolute",
    right: "15px",
    bottom: 0,
    textTransform: "none",
    color: colors.FOLLOW_BUTTON_TEXT,
    backgroundColor: colors.FOLLOW_BUTTON_BG,
    height: "40px",
    width: "130px",
    fontSize: "16px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.03px",
    "&:hover": {
      background: colors.FOLLOW_BUTTON_BG,
    },
  },
}));

export default function HeaderDesktop({
  statement,
  titleIsLink,
  backgroundImageUrl,
  statementNavigation,
}: Props) {
  const classes = useStyles();
  const { user } = useAuth();
  const [vote, setVote] = useState<VoteType | null>(null);

  useEffect(() => {
    if (!user || !statement) return;
    const unsubscribe = getStatementVote(statement.id, user.id, setVote);
    return () => unsubscribe();
  }, [user, statement]);

  return (
    <Grid container item xs={12}>
      {(() => {
        if (vote && vote === AGREE) {
          return <div className={classes.headerBackground} style={{backgroundColor: colors.AGREED}} />
        } else if (vote && vote === DISAGREE) {
          return <div className={classes.headerBackground} style={{backgroundColor: colors.DISAGREE}} />
        } else {
          return <div className={classes.headerBackground}/>
        }
      })()}
      
        <Paper
          className={classes.header}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
            opacity: "80%",
          }}
        />
        <Grid className={classes.statementContainer} container item sm={12}>
          <Grid container item sm={12} className={classes.statementNav}>
            {statementNavigation}
          </Grid>

          <Grid className={classes.textContainer} container item sm={12}>
            <Grid item sm={1} />
            <Grid item sm={10} className={classes.statementTitleContainer}>
              <Typography component="h1" className={classes.statementTitle}>
                <StatementLink
                  slug={statement.slug}
                  className={classes.statementLink}
                  clickable={titleIsLink}
                >
                  {statement.title}
                </StatementLink>
              </Typography>
            </Grid>
            <Grid item sm={1} />
          </Grid>

          <Grid container className={classes.container} item sm={12}>
            <Grid item sm={2} />
            <Grid item sm={8} className={classes.votingContainer}>
              <Voting statement={statement} />
            </Grid>
            <Grid item sm={2} className={classes.followContainer}>
              <div>
                <Following
                  statement={statement}
                  className={classes.followButton}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      {/* </Paper> */}
    </Grid>
  );
}
